<template>
    <div class="row">
        <div class="col-12 active">
            <div class="card active">
                <div class="card-body mini-nav bg-primary pt-2 pb-3 active ">
                    <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">
                        <button
                                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                                aria-label="Toggle navigation">
                            <span class="mdi mdi-menu"></span>
                        </button>
                        <div class="collapse navbar-collapse justify-content-between active"
                             id="navbarNavAltMarkup">
                            <div class="navbar-nav">
                                <a v-if="getRight('PENDING PWD')" :class="activeClass" @click="gotTo('pwd-pending')" href="javascript:void(0)">Pending PWD</a>
                                <a v-if="getRight('APPROVED PWD')" :class="activeClass2" @click="gotTo('pwd-approved')" href="javascript:void(0)">Approved PWD</a>
                                <a v-if="getRight('DECLINED PWD')" :class="activeClass3" @click="gotTo('pwd-declined')" href="javascript:void(0)">Declined PWD</a>
                                <a v-if="getRight('REVERTED PWD')" :class="activeClass4" @click="gotTo('pwd-reverted')" href="javascript:void(0)">Reverted PWD</a>
                            </div>

                        </div>
                    </nav>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {execute, parking,getRight} from "@/api";

    export default {
        name: "ToolBarPwd",
        data(){
            return{
                todayHighlights:[
                    {
                        title: "LOGGED VEHICLES",
                        amount: "41,695"
                    }
                ],
                subCountyName:'',
                currentPage:'',
            }
        },
        mounted() {
            this.currentPage = sessionStorage.getItem("currentPage")
        },

        computed: {
            activeClass() {
                return {
                    'nav-item': true,
                    'nav-link': true,
                    'active': this.currentPage === 'pwd-pending'
                }
            },
            activeClass2() {
                return {
                    'nav-item': true,
                    'nav-link': true,
                    'active': this.currentPage === 'pwd-approved'
                }
            },
            activeClass3() {
                return {
                    'nav-item': true,
                    'nav-link': true,
                    'active': this.currentPage === 'pwd-declined'
                }
            },
            activeClass4() {
                return {
                    'nav-item': true,
                    'nav-link': true,
                    'active': this.currentPage === 'pwd-reverted'
                }
            },

        },
        methods:{
          getRight(role){
            return getRight(role)
          },
            gotTo(route){
                sessionStorage.setItem("currentPage",route)
                this.$router.push(route);
            },
            getTodayHighlights(){
                this.todayHighlights.splice(0)
                const data = new FormData();
                data.append("function", "todayHighlights");
                execute(data,parking)
                    .then((res) =>{
                        if (res.data.success) {
                            this.todayHighlights = res.data.data.todayHighlights

                        }else{
                            this.message =res.data.message
                        }
                    })
                    .catch((e) => {
                        this.message =e.message
                    });
            },
        }
    }

</script>

<style scoped>

</style>